require('devbridge-autocomplete');

function HomeSiteSearchModule() {
  let container;
  let input;
  let button;

  // Utility functions (copied from koautocomplete.js for formatting)
  const utils = {
    escapeRegExChars: function (value) {
      return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
    },
  };

  // Autocomplete options (simplified, focusing on transform and format)
  const autocompleteOptions = {
    appendTo: '.home__site-search-module--searchbox',
    width: '100%',
    position: 'bottom',
    serviceUrl: '/api/sitecore/sitesearch/gettypeahead',
    noCache: true,
    minChars: 3,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    triggerSelectOnValidInput: false,
    params: { section: null, field: null },
    onSelect: function (value) {
      if (value.isLink === true) {
        window.location.href = value.Url;
      } else {
        input.value = value.value;
        runSearch();
      }
    },
    transformResult: function (response, originalQuery) {
      // from koautocomplete.js
      let autoCompleteResultCount = 0;
      const maxResults = 20;
      return {
    suggestions: $.map(response, function (dataItem) {
      if (autoCompleteResultCount < maxResults) {
        autoCompleteResultCount++;
        return {
          data: { category: dataItem.Category, id: dataItem.ID },
          value: dataItem.Name,
          Url: dataItem.Url,
          isLink: dataItem.IsLink,
          CssClass: dataItem.CssClass,
        };
      }
          return [];
        }),
      };
    },
    formatResult: function (suggestion, currentValue) {
      // Copied from koautocomplete.js
      let termArry = currentValue
        .replace('"', '')
        .replace('”', '')
        .replace('“', '')
        .split(' ');
      let formattedResult = suggestion.value;
      let pattern = '';
      if (termArry.length > 0) {
        termArry = termArry.sort(function (a, b) {
          return b.length - a.length;
        });
        for (let i = 0; i < termArry.length; i++) {
          let keyTerm = termArry[i].trim().replace('"', '').replace('"', '');
          if (keyTerm.length > 0) {
            pattern =
              '((\\s' +
              utils.escapeRegExChars(keyTerm) +
              ')|(^' +
              utils.escapeRegExChars(keyTerm) +
              ')|(\\s"' +
              utils.escapeRegExChars(keyTerm) +
              '))(?![^<>]*>)';
            formattedResult = formattedResult.replace(
              new RegExp(pattern, 'gi'),
              '<span class="auto-term">$1<\/span>',
            );
          }
        }
      }
      return "<span class='label'>" + formattedResult + '</span>';
    },
  };

  const init = () => {
    container = document.querySelector(
      '.home__site-search-module.js-site-search-module',
    );
    if (!container) return;

    input = container.querySelector(
      '.home__site-search-module--searchbox-input',
    );

    button = container.querySelector(
      '.home__site-search-module--searchbox-button',
    );
    
    if (!input || !button) return;

    button.addEventListener('click', runSearch);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        runSearch();
      }
    });

    $(input).autocomplete(autocompleteOptions);
  };

  const runSearch = () => {
    const query = encodeURIComponent(input.value.trim());
    if (query.length === 0) return;

    const searchUrl = `/sitesearch?query=${query}`;
    window.location.assign(searchUrl);
  };

  return {
    init,
  };
}

document.addEventListener('DOMContentLoaded', () => {
  const siteSearchModule = HomeSiteSearchModule();
  siteSearchModule.init();
});
